import React, { useEffect, useState } from "react";
import { useAuthQuery as useQuery } from '../../../../shared/hooks/useAuthQuery';
import { useConvexAuth, useMutation } from "convex/react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../convex/_generated/api";
import { AdminRoutes, MainRoutes, SystemAssistant } from "../../../../shared/models";
import { Button } from "../../../../catalyst-components/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../catalyst-components/table";
import { Alert, AlertActions, AlertDescription, AlertTitle } from "../../../../catalyst-components/alert";
import { ConfirmationDialog } from "../../../../catalyst-components/confirmation-dialog";
import { Id } from "../../../../convex/_generated/dataModel";

export const SystemAssistants: React.FC = () => {
    const { isAuthenticated } = useConvexAuth();
    const navigate = useNavigate();
    const assistants = useQuery(api.system_assistants.list) || [];
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState<{
        open: boolean;
        assistant?: SystemAssistant;
    }>({ open: false });

    useEffect(() => {
        if (!isAuthenticated) {
            navigate(MainRoutes.Landing);
        }
    }, [isAuthenticated]);

    return (
        <section className="min-h-screen bg-background pt-24 px-6 flex flex-col justify-start">
            <h1 className="text-3xl font-bold mb-4">System Assistants</h1>
            <div className="flex flex-row gap-4 mb-6">
                <Button color="light" onClick={() => navigate('../')}>
                    Back to admin
                </Button>
            </div>
            <p className="text-gray-600 mb-4">
                Manage system-level assistants and their configurations. These assistants handle core system functionalities.
            </p>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeader>Name</TableHeader>
                        <TableHeader>Modified</TableHeader>
                        <TableHeader>Modified By</TableHeader>
                        <TableHeader>Actions</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {assistants
                        .sort((a, b) => a._creationTime - b._creationTime > 0 ? -1 : 1)
                        .map(assistant => (
                            <TableRow key={assistant._id}>
                                <TableCell>
                                        {assistant.name}
                                </TableCell>
                                <TableCell>{new Date(assistant.timestamp_modified).toLocaleDateString()}</TableCell>
                                <TableCell>{assistant.modified_by}</TableCell>
                                <TableCell>
                                    <div className="flex gap-2">
                                        <Button color="light" onClick={() => navigate(`${AdminRoutes.ViewSystemAssistant}/${assistant._id}`)}>
                                            View Details
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>

            <Alert open={showAlert} onClose={() => setShowAlert(false)} size="lg">
                <AlertTitle>Notification</AlertTitle>
                <AlertDescription>{alertMessage}</AlertDescription>
                <AlertActions>
                    <Button plain onClick={() => setShowAlert(false)}>
                        Ok
                    </Button>
                </AlertActions>
            </Alert>
        </section>
    );
}; 